/**
 * /app/trusts/$id/loa-low — Letters of Authority + Letters of Wishes (route shell).
 *
 * Screen impl in `./loa-low-screen.tsx`, lazy-loaded. A trust sub-tab, not a
 * first-paint route (the trust overview + dashboard stay eager); the LoA/LoW
 * panels + upload modal are sizeable, so they leave the initial bundle.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/trusts/$id/loa-low')({
  component: lazyRouteComponent(() => import('./loa-low-screen'), 'LoaLowScreen'),
});
